
/* injects from baggage-loader */

'use strict';

export default function (app) {
	app.service('AccountInvitation', function (Parse) {

		// Properties
		let schema = [
			'email',
			'invitationCode',
			'role',
			'accepted',
			'user',
			'group'
		];

		let AccountInvitation = Parse.Object.extend('AccountInvitation', {
			// Instance methods

		}, {
			// Class methods

			getByInvitationCode(code) {
				return Parse.Cloud.run('lookupInvitation', {
					invitationCode: code
				});
			},
		
			findPending() {
				let query = new Parse.Query(this);
				query.notEqualTo('accepted', true)
				return query.find();
			},

		});

		// Define object properties
		schema.forEach(function (field) {
			Object.defineProperty(AccountInvitation.prototype, field, {
				get: function () { return this.get(field); },
				set: function (value) { return this.set(field, value); }
			});
		});

		return AccountInvitation;

	});
}




// WEBPACK FOOTER //
// ./src/app/core/services/parse/accountinvitation.service.js